<template>
  <v-container class="my-0 py-o pt-5">
    <v-form ref="supportForm">
      <v-row>
        <v-col class="py-0 px-3" cols="12" sm="6" md="2">
          <label>Operadora</label>
          <v-select
            v-model="formData.operadora_ans_id"
            :items="operadorasList"
            item-value="id"
            item-text="oper_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="py-0 px-3" cols="12" sm="6" md="2">
          <label>Intervalo</label>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="monthWeek"
            placeholder="Selecione"
            outlined
            item-value="value"
            item-text="label"
            :items="[{label:'Mês', value: 'mes'}, {label:'Semana', value: 'semana'}]"
          ></v-select>
        </v-col>
        <v-col class="py-0" cols="12" sm="12" md="8">
          <div v-if="showPicker">
            <v-row class="ma-0">
              <v-col class="py-0 px-2" cols="12" sm="6" md="5">
                <span class="group pr-1">
                  <v-icon color="#035A27" x-small style="font-size:13px;">fa-circle</v-icon>
                </span>
                <span>Período 1</span>
                <v-menu
                  ref="dtI"
                  v-model="dtI"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateP1Formatted"
                      dense
                      v-mask="monthWeek=='semana'? dateP1 != null ? '##/##/#### ~ ##/##/####' : '##/##/####' : '##/####'"
                      :format="monthWeek=='semana'? null: 'MM/YYYY'"
                      :placeholder="monthWeek=='semana'? 'DD/MM/YYYY': 'MM/YYYY'"
                      :readonly="false"
                      label
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar-blank"
                      :rules="formRules.required"
                      @blur="dateP1 = monthWeek=='mes'? parseDate(dateP1Formatted) : selectRange([parseDate(dateP1Formatted)])"
                    ></v-text-field>
                  </template>
                  <v-date-picker 
                    color="primary"  
                    first-day-of-week=1 
                    :range="monthWeek=='semana'? true: false" 
                    @input="monthWeek=='semana'? dateP1 = selectRange(dateP1) : null" 
                    :type="datePickerType"
                     v-model="dateP1" 
                    no-title 
                    scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-0 px-2" cols="12" sm="6" md="5">
                <span class="group pr-1">
                  <v-icon color="#31B1FF" x-small style="font-size:13px;">fa-circle</v-icon>
                </span>
                <span>Período 2</span>
                <v-menu
                  ref="dtF"
                  v-model="dtF"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateP2Formatted"
                      v-mask="monthWeek=='semana'? dateP2 != null ? '##/##/#### ~ ##/##/####' : '##/##/####' : '##/####'"
                      :format="monthWeek=='semana'? null: 'MM/YYYY'"
                      :placeholder="monthWeek=='semana'? 'DD/MM/YYYY': 'MM/YYYY'"
                      :readonly="false"
                      label
                      dense
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar-blank"
                      @blur="dateP2 = monthWeek=='mes'? parseDate(dateP2Formatted) : selectRange([parseDate(dateP2Formatted)])"
                      :rules="formRules.required"
                    ></v-text-field>
                      <!-- @blur="dateP2 = parseDate(dateP2Formatted)" -->
                  </template>
                  <v-date-picker color="primary"  
                    first-day-of-week=1 
                    :range="monthWeek=='semana'? true : false"
                    @input="monthWeek=='semana'? selectRange(dateP2, 'dateP2') : null" 
                    :type="datePickerType" 
                    v-model="dateP2" 
                    no-title 
                    scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mt-2 px-2" cols="12" sm="6" md="2">
                <v-btn
                height="30px"
                small
                style="padding: 0 10px"
                depressed
                color="primary"
                @click="sendForm()"
                >Gerar gráfico</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import moment from "moment"
moment.locale('pt-BR');
export default {
  data() {
    return {
      formData: {
        operadora_ans_id: null,
        periodo: 'mes', 
        data_referencia1: '2020-10-01',
        data_referencia2: '2020-09-01'
      },
      monthWeek: '',
      operadorasList: [],
      dateP1: null,
      dateP1Formatted: null,      
      dateP2: null,
      dateP2Formatted: null,
      dtI: false,
      dtF: false,
      showLine: false,
      showPicker: false,
      datePickerType: 'month',
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  methods: {
    sendForm() {
      if (this.$refs.supportForm.validate()) {
        this.showLine = true
        this.filterChart(this.formData)
      }  
    },
    parseDateMonth(date) {
      if (!date || date=="" || (date[0] && !date[0])) return null;
      let [month, year] = date.split("/");
      return `${year}-${month}`
    },
    parseDateWeek(date) {
      if (!date || date=="" || (date[0] && !date[0])) return [];
      let day = date.substring(0,2)
      let month = date.substring(3,5)
      let year = date.substring(6,10)
      return `${year}-${month}-${day}`
    },
    parseDate(date) {
      if(this.monthWeek!="semana"){
        return this.parseDateMonth(date)
      }if(this.monthWeek=="semana"){
        return this.parseDateWeek(date)
      } else {
        return null
      }
    },
    formatDate(date) {
      if (!date || (date !=='string' && date[0] == null)){
        return  null
      }
      if (typeof date ==='string' &&  this.monthWeek == "semana"){
        return null
      }
      if (this.monthWeek == "mes") {
        let [year, month] = date.split("-");
        return `${month}/${year}`
      }
      if (this.monthWeek == "semana") {
        let dayI =  moment(date[0]).format('DD/MM/YYYY');
        let dayF = moment(date[1]).format('DD/MM/YYYY');
        return `${dayI} ~ ${dayF}`
      }
    },
    selectRange(date, variable) { // Pega a data seleciona o range
      if (!date || date[0]==null) return null;
      let val = date[0]
      let day = new Date(val).getDay()
      let dayI =  moment(val).subtract(day, 'days').format('YYYY-MM-DD');
      let dayF = moment(val).add(6-day, 'days').format('YYYY-MM-DD');
      if(variable){
        this[variable] = [dayI ,dayF]
      }
      return [dayI ,dayF]
    },
    currentData(val) {
      this.showPicker = false
      this.monthWeek = val.periodo? val.periodo : this.monthWeek
      this.formData.periodo = val.periodo? val.periodo : this.formData.periodo 
      this.$nextTick(() => {
        this.dateP1 = val.periodo == 'semana'? this.selectRange(val.data_referencia1[0].split('T')) : moment(val.data_referencia1[0]).format('YYYY-MM')
        this.dateP2 = val.periodo == 'semana'? this.selectRange(val.data_referencia2[0].split('T')) : moment(val.data_referencia2[0]).format('YYYY-MM')
        // setTimeout(() => {   
        this.showPicker = true
        // }, 50);
      })
     
    },
  },  
  props: {
    currentLine: Object,
    filterChart: Function,
    operadoras: Array
  },
  watch: {
    currentLine(val) {
      this.currentData(val)
    },
     monthWeek(val){
      this.showPicker = false
        this.dateP1 = this.monthWeek=='semana'? [null, null] : null
        this.dateP2 = this.monthWeek=='semana'? [null, null]  : null
        this.dateP1Formatted = null
        this.dateP2Formatted = null
        this.formData.periodo = val
        this.$nextTick(()=>{
          this.datePickerType = this.monthWeek=='semana' ? 'date': 'month'
          this.showPicker = true
        })
    },
    operadoras(val){
      this.operadorasList = Array.from(val)
      this.operadorasList.unshift({id: null, oper_nome: "Todas"})
    },
    dateP1(val) {
      this.dateP1Formatted = this.formatDate(val)
    },
    dateP2(val) {
      this.dateP2Formatted = this.formatDate(val)
    },
    dateP1Formatted(val) {
      let date = this.parseDate(val)
      this.formData.data_referencia1 = this.monthWeek == 'semana' ? date : `${date}-01`
      if (this.monthWeek == 'semana' && date.length==0) {
        this.dateP1 = null
      }
    },
    dateP2Formatted(val) {
      let date = this.parseDate(val)
      this.formData.data_referencia2 = this.monthWeek == 'semana' ? date : `${date}-01`
      if (this.monthWeek == 'semana' && date.length==0) {
        this.dateP2 = null
      }
    }
  },
  mounted() {
    this.operadorasList = Array.from(this.operadoras)
    this.operadorasList.unshift({id: null, oper_nome: "Todas"})
    this.$nextTick()
  }
};
</script>
